import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from './styles';
export const Spinner = ({ color }) => {
    return (_jsxs(Container, { "$color": color, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
};
